// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserInitialsAvatar_avatar__yz8ZU","avatarInner":"UserInitialsAvatar_avatarInner__LfrJ_"};